
const reviews = [
  {
    review:
      "I am so happy with Treat it service, doctors were really professional, respectful and friendly. Once I was approved by two doctors to",
    nameDate: "Vitor - January 2025",
    profile: "https://user-images.trustpilot.com/606f04019ac5de001b1ea3b4/73x73.png"
  },
  {
    review:
      "Excellent service. At last some enlightened doctors! So happy not to have my stomach damaged by hefty painkillers. Finally some comforting news.",
    nameDate: "Kate - January 2025",
    profile: "https://user-images.trustpilot.com/59e51d270000ff000ad5c707/73x73.png"
  },
];

export default reviews;
